import { createValidation } from '_metronic/helpers'
import { TFunction } from '_metronic/i18n/Metronici18n'
import * as Yup from 'yup'

export const grupoPerfisSchema = (t: TFunction) => {
  const v = createValidation(t)

  return Yup.object().shape({
    perfis: Yup.array().min(1, v.requiredField('permissao', 'array')),
  })
}
